import { CardContent, CardHeader, Card } from '@mui/material';
import parentStyles from '../OrganizationGeneral.module.scss';
import { SupplierIconUpload } from './SupplierIconUpload/SupplierIconUpload';

export interface OrganizationIconUploadProps {
    /** A supplierId for the supplier that an admin user wants to view data for. */
    viewAsSupplier?: string;
}
export const OrganizationIconUpload = ({
    viewAsSupplier,
}: OrganizationIconUploadProps) => {
    const subHeadText =
        'This icon will show up in the App. We recommend 45px by 164px with a transparent background';
    return (
        <div data-testid="OrganizationIconUpload">
            <Card className={parentStyles.card}>
                <CardHeader title="Icon Upload" subheader={subHeadText} />
                <CardContent>
                    <SupplierIconUpload viewAsSupplier={viewAsSupplier} />
                </CardContent>
            </Card>
        </div>
    );
};
